import type { UploadFile } from '@/hooks/residents/useChatAttachments';

type BuildParams = {
  content?: string;
  isAdmin?: boolean;
  files?: UploadFile[];
  extras?: Record<string, string | number | boolean | undefined>;
};

export const buildMessageFormData = ({ content, isAdmin = false, files = [], extras = {} }: BuildParams) => {
  const formData = new FormData();
  if (typeof content === 'string') {
    formData.append('content', content);
  }
  formData.append('isAdmin', String(isAdmin));
  Object.entries(extras).forEach(([key, value]) => {
    if (value !== undefined && value !== null) formData.append(key, String(value));
  });
  files.forEach((file) => {
    if (file.file) {
      formData.append('files', file.file);
    } else if (file.uri) {
      formData.append('files', { uri: file.uri, type: file.type, name: file.name } as any);
    }
  });
  return formData;
};

export default buildMessageFormData;


